import type { ProcessableImageType, ProcessableServerImageType } from '@/types/common.types'

export const normalizeImage = (image: ProcessableServerImageType): ProcessableImageType => ({
  key: image.key,
  baseUrl: image.base_url,
  contentType: image.content_type,
  url: image.url,
})
